import React from 'react';
import RedirectLegal from './RedirectLegal';

export default function Terms() {
  return <RedirectLegal care="termeni" />;
}
